module.exports = __webpack_public_path__ + "media/images/covid/icons/tray-371d4ec805919bd37019f3a027de99e7.svg";